import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { DoctorProfileService } from '../../../core/services/doctor-profile.service';
import { NotificationService } from '../../../core/services/notification.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password-email.html',
  imports: [ReactiveFormsModule, RouterLink],
  styleUrls: ['./forgot-password-email.scss'],
})
export class ForgotPasswordEmail {
  forgotPasswordForm: FormGroup;
  isLoading: boolean = false;
  errorMessage: string | null = null;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private profileService: DoctorProfileService,
    private notificationService: NotificationService,
  ) {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  submitForgotPassword() {
    this.errorMessage = null;
    if (this.forgotPasswordForm.invalid) {
      this.forgotPasswordForm.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    const email = this.forgotPasswordForm.value.email;

    this.profileService.requestOtp(email, 'FORGOT_PASSWORD').subscribe({
      next: (preAuthToken) => {
        this.isLoading = false;
        this.notificationService.success('Verification OTP has been sent to your email.');
        this.router.navigate(['/forgot-password-otp'], {
          state: { email: email, preAuthToken: preAuthToken },
        });
      },
      error: (err) => {
        this.isLoading = false;
        const msg =
          err?.error?.message || 'Failed to send OTP. Please verify your email and try again.';
        this.errorMessage = msg;
        this.notificationService.error(msg, 'Request Failed');
      },
    });
  }
}
